import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControlLabel as MUIFormControlLabel,
  Switch as MUISwitch
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { fonts } from '@constants/fonts';

const useStyles = makeStyles()(theme => ({  // eslint-disable-line no-unused-vars
  label: {
    fontSize: fonts.md
  }
}));

export const Switch = props => {
  const {
    label = '',
    labelPlacement = 'end',
    color = 'primary',
    style,
    // v9 removed Switch/SwitchBase's own `inputProps` prop entirely (now `slotProps.input`) —
    // translated here so existing callers (e.g. base-filter.js's aria-label) don't need to change.
    inputProps,
    slotProps,
    ...data
  } = props;

  // `classes` here (if any) targets MUISwitch's own classKeys (root, switchBase, thumb,
  // track, checked, ...) via `...data` below - it must never reach our own `useStyles`
  // hook, which only defines a `label` key and would otherwise fail to validate them.
  const { classes } = useStyles();

  const mergedSlotProps = {
    ...slotProps,
    ...(inputProps && { input: { ...inputProps, ...slotProps?.input } })
  };

  if (!label) {
    return <MUISwitch {...data} color={color} style={style} slotProps={mergedSlotProps} />;
  }

  return (
    <MUIFormControlLabel
      control={<MUISwitch {...data} color={color} slotProps={mergedSlotProps} />}
      classes={{
        label: classes.label
      }}
      style={style}
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

Switch.propTypes = {
  classes: PropTypes.object,
  color: PropTypes.string,
  inputProps: PropTypes.object,
  label: PropTypes.node,
  labelPlacement: PropTypes.string,
  slotProps: PropTypes.object,
  style: PropTypes.object
};

export default Switch;
